/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

export const GET_BREAKDOWN_QUEUE = '[Library] Get Breakdown Queue';
export const GET_BREAKDOWN_QUEUE_SUCCESS = '[Library] Get Breakdown Queue Success';
export const GET_BREAKDOWN_QUEUE_FAIL = '[Library] Get Breakdown Queue Fail';
export const RESET_BREAKDOWN_QUEUE = '[Library] Reset Breakdown Queue';

export class GetBreakdownQueue implements Action {
  readonly type = GET_BREAKDOWN_QUEUE;

  constructor(public payload: { userId: number; userType: string; userProducts: any[] }) {}
}

export class GetBreakdownQueueFail implements Action {
  readonly type = GET_BREAKDOWN_QUEUE_FAIL;

  constructor(public payload: any) {}
}

export class GetBreakdownQueueSuccess implements Action {
  readonly type = GET_BREAKDOWN_QUEUE_SUCCESS;

  constructor(public payload: any) {}
}

export class ResetBreakdownQueue implements Action {
  readonly type = RESET_BREAKDOWN_QUEUE;

  constructor() {}
}

// action types
export type GetBreakdownQueueAction =
  | GetBreakdownQueue
  | GetBreakdownQueueFail
  | GetBreakdownQueueSuccess
  | ResetBreakdownQueue;
